// config.js
export const APP_URL = process.env.REACT_APP_API_URL;
export const AGENT_ID = "5";
